import { SVGProps, Ref, forwardRef } from 'react';

export const GhostFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 1C6.498.942 2.83 4.69 2.547 10l-.544 10.9c-.08 1.6 1.687 2.638 3.077 1.808l1.781-1.064a2.05 2.05 0 0 1 2.145.026l1.354.854c1 .63 2.28.63 3.28 0l1.353-.854a2.05 2.05 0 0 1 2.146-.026l1.78 1.064c1.391.83 3.158-.208 3.078-1.809l-.544-10.9C21.172 4.69 17.504.942 12 1.002m1.25 8.5c0-.875.438-1.75 1.75-1.75s1.75.875 1.75 1.75-.437 1.75-1.75 1.75-1.75-.875-1.75-1.75M9 7.75c-1.312 0-1.75.875-1.75 1.75s.438 1.75 1.75 1.75 1.75-.875 1.75-1.75S10.313 7.75 9 7.75"
                fill="currentColor"
            />
        </g>
    </svg>
));
GhostFilledSize24Glyph.displayName = 'GhostFilledSize24Glyph';
